import { Redirect } from 'types/suggestions';
import { patchUrlByLocale } from 'utils/patch-url-by-locale';
import { SearchHistoryItem } from '../use-search-history-context';
import { navigate } from './utils';
import { getURLWithLoggingContext } from 'utils/get-url-with-logging-context';

export const handleRedirect = (
  redirect: Redirect,
  addHistoryItem: (item: SearchHistoryItem) => void,
  responseId: string,
) => {
  const { pageUrl, name, type } = redirect;
  const url = pageUrl ? getRedirectUrl(pageUrl) : getFallbackUrl(name);

  const resultURL = getURLWithLoggingContext(url, responseId, name, type, 'redirect');

  if (resultURL) {
    addHistoryItem({
      title: name,
      url: resultURL,
    });
    navigate(resultURL);
  }
};

export const getRedirectUrl = (url: string) => {
  return patchUrlByLocale({
    url: url.endsWith('.html') ? `${url.slice(0, -5)}/` : url,
  });
};

export const getFallbackUrl = (name: string) => {
  const searchParams = new URLSearchParams();
  searchParams.append('q', name);
  searchParams.append('suggest', 'true');
  return patchUrlByLocale({ url: `/search/?${searchParams}` });
};
